import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { L10nTranslationModule } from 'angular-l10n';
import { ToastrModule } from 'ngx-toastr';
import { CustomSnackComponent } from './custom-snack/custom.snack.component';
import { CustomToastComponent } from './custom-toast/custom-toast.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';

@NgModule({
  imports: [
    CommonModule,
    MatSnackBarModule,
    L10nTranslationModule,
    ToastrModule.forRoot({
      toastComponent: CustomToastComponent,
    }),
    CustomToastComponent,
    CustomSnackComponent,
  ],
  exports: [],
})
export class CbreAlertsModule {}
